export default __webpack_public_path__ + "static/media/card800.4ec4622e.jpg";